import { trackLoggedOutRetailersLoggedOutHomeRedesignCtaClick } from "@faire/web-api/events/loggedOutRetailers/click/loggedOutHomeRedesignCta";
import { IBlogCarouselTile } from "@faire/web-api/indigofair/data/IBlogCarouselTile";
import { Column } from "@faire/web/slate/Layout";
import { Typography } from "@faire/web/slate/Typography";
import { Anchor } from "@faire/web/ui/LinkAnchor";
import classNames from "classnames";
import React from "react";

import * as animationStyles from "@faire/retailer/views/home/logged-out-homepage/__internal__/components/__internal__/Animation/animation.css";
import * as linkStyles from "@faire/retailer/views/home/logged-out-homepage/__internal__/components/__internal__/Link/link.css";
import { LoggedOutHomeImage } from "@faire/retailer/views/home/logged-out-homepage/__internal__/components/__internal__/LoggedOutHomeImage/LoggedOutHomeImage";

import * as componentStyles from "./styles.css";

export const BlogTile: React.FC<{ blogTile: IBlogCarouselTile }> = ({
  blogTile,
}) => {
  const { cta_link_url, image, below_image_title } = blogTile;
  if (!image || !cta_link_url || !below_image_title) {
    return null;
  }

  return (
    <Anchor
      href={cta_link_url}
      className={classNames(
        animationStyles.animationHoverTarget,
        linkStyles.linkParent
      )}
      onClick={() => {
        trackLoggedOutRetailersLoggedOutHomeRedesignCtaClick(
          "blog_carousel-blog-post",
          cta_link_url
        );
      }}
    >
      <Column gap={12} className={componentStyles.blogTile}>
        <div className={animationStyles.imageContainer}>
          <LoggedOutHomeImage
            lazyLoad
            responsiveImage={{
              mobileAndAbove: image,
            }}
            optimizeImageOptions={{
              width: componentStyles.IMAGE_WIDTH,
              height: componentStyles.IMAGE_HEIGHT,
              resizeMethod: "fill",
            }}
            altText={image.alt_text}
            className={classNames(
              componentStyles.image,
              animationStyles.imageZoom
            )}
          />
        </div>
        <Typography variant="paragraphSansRegular" className={linkStyles.link}>
          {below_image_title}
        </Typography>
      </Column>
    </Anchor>
  );
};
